// Func = limiting Scope for this file
var lastScrollTop = 0;


(function(){

	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		let s = skrollr.init({
			forceHeight: false,
			mobileCheck: function() {
				return false;
            }
		});

		/* GDPR Popup Rewrites comes from CMS */
		$('a.learnmore').each(function() {
		    $(this).attr('id', 'privacyCookie').attr('target', '_blank');
		    var link = document.getElementById("privacyCookie");

		    link.innerHTML = '"Our Privacy and Cookie Policy"';
		    link.setAttribute('href', "https://www.thedalmar.com/privacy-policy");
		});
		 
	});

	window.onload = function() {
		scrollW();
		animLine();
		fadeUp();
		window.addEventListener('scroll', function(){
			scrollW();
			animLine();
			fadeUp();
			menuActiveItem();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow(){
	console.log('resize');
}

function animLine(){
	let $lines = document.getElementsByClassName('vLine');
	let triggerPoint = window.outerHeight * 0.5;
	for(let $line of $lines){
		let lineTop = $line.getBoundingClientRect().top;
		if(triggerPoint > lineTop){
			$line.classList.add('animate');
		}
	}
}
function fadeUp(){
	let $lines = document.getElementsByClassName('js-fadeUp');
	let triggerPoint = window.outerHeight * 0.8;
	for(let $line of $lines){
		let lineTop = $line.getBoundingClientRect().top;
		if(triggerPoint > lineTop){
			$line.classList.add('animate');
		}
	}
}

function menuActiveItem () {
	let sections = document.querySelectorAll(".js-sectionModule");
	let scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

	for (let section of sections) {
		let navItem = document.querySelector('.privary-navigation__item a[href*="#' + section.id + '"]');
		if (section.offsetTop <= scrollPosition && section.offsetTop + section.offsetHeight > scrollPosition) {
			if (navItem) {
				for (let item of document.querySelectorAll('.privary-navigation__item a')) {
					item.classList.remove('active');
				}
				navItem.classList.add('active');
			} else {
				for (let item of document.querySelectorAll('.privary-navigation__item a')) {
					item.classList.remove('active');
				}
			}
		}
	}
}


